import React, { Fragment } from "react";
import GenericApp from "../GenericApp";
import ContactAppForm from "./ContactAppForm";
import { useDispatch, useSelector } from "react-redux";
import GenericAppUtils from "../GenericApp/GenericAppUtils";
import { useHistory } from "react-router-dom";
import IntlMessages from "../../../@jumbo/utils/IntlMessages";
import { useIntl } from "react-intl";
import AttachFileIcon from "@material-ui/icons/Attachment";
import { CONTACT_DESTROY, CONTACT_STORE, CONTACT_UPDATE } from "../../../redux/action-types/ContactActionTypes";
import FileUploaderActions from "../../../redux/sagas/actions/FileUploaderActions";
import SmsSenderDialog from "../../../components/dialog/SmsSenderDialog";
import MessageIcon from "@material-ui/icons/Message";

export const CONTACT_FRONTEND_INDEX_URL = '/apps/contact';
export const CONTACT_PAGINATE_URL = '/Contact/Paginate';
const NAME = 'contact-app';
const TITLE = 'Contact';
const SUBTITLE = 'App';
const ICON = <AttachFileIcon />;

function ContactApp(props) {

  const dispatch = useDispatch();
  const hist = useHistory();
  let { page, pageLimit } = useSelector(({ genericAppReducer }) => genericAppReducer);
  const intl = useIntl();

  const handleIndex = () => {
    hist.push(CONTACT_FRONTEND_INDEX_URL);
  }

  const handleDestroy = (values) => {
    dispatch({type: CONTACT_DESTROY, payload: values});
  };

  const handleSubmit = (values, formik) => {
    const type = values.id ?  CONTACT_UPDATE : CONTACT_STORE;
    dispatch({type: type, payload: values});
  };

  const AppSettings = {
    name: `${NAME}-app`,
    title: <IntlMessages id={TITLE} />,
    subTitle: SUBTITLE,
    searchTitle: intl.formatMessage({ id: 'Search...' }),
    notFoundTitle: <IntlMessages id={'No records found'} />,
    isCreate: true,
    isRead: true,
    isUpdate: true,
    isDelete: true,
    urls: {
      indexFrontend: CONTACT_FRONTEND_INDEX_URL
    },
    createButton: {
      title: <IntlMessages id={'Create New'} />,
      icon: null
    },
    headers: [
      <IntlMessages id={'Name'} />,
      <IntlMessages id={'Id'} />,
      <IntlMessages id={'Cellphone'} />
    ],
    menuList: [
      {
        title: "Menu",
        items: [
          { id: 1, name: <IntlMessages id={TITLE} />, slug: `${NAME}-all`, icon: ICON, onClick: handleIndex }
        ]
      }
    ],
    componentList: [ // to access the current on the list this component is tied to. Use the property: props.listItem
      SmsSenderDialog
    ],
    recordMenuList: [
      {
        title: "Record Menu",
        items: [
          // { id: 1, name: "Send Sms", slug: "send-sms", icon: <MessageIcon />, onClick: (e) => handleSmsMenuItemClick(e) }
        ]
      }
    ],
    dispatchActions: {
      paginate: GenericAppUtils.GetPaginateFunc(CONTACT_PAGINATE_URL),
    },
    events: {
      onRenderTitle: (item) => (item.name),
      onRenderSubTitle: (item) => (item.email),
      onRenderAvatar: (item) => (FileUploaderActions.getDownloadImageUrl(item.profilePictureUrl, false)),
      onRenderExtraCells: (item) => ([item.id, item.cellphone]),
      onEditClick : (item) => console.log(item),
      onShowClick : (item) => console.log(item),
      onDeleteClick : handleDestroy,
      onDeleteMultiple : (items) => console.log(items),
      onCreateClick : (e) => console.log(e),
      onStarClick: null, //(item, status) => console.log(item, status),
      onSearchChange: null,//(s) => console.log(s),
      onSearchEnterKeyDown: null, //if this property is null, it will call the default search endpoint
    }
  };

  return (
    <Fragment>
      <GenericApp appSettings={AppSettings} form={<ContactAppForm onSubmit={handleSubmit}/>} isUseDialog={false} />
    </Fragment>
  );

}

export default ContactApp;
